import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=4b7a9a60&scoped=true&"
import script from "./ServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=4b7a9a60&lang=scss&scoped=true&"
import style1 from "./ServiceDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a9a60",
  null
  
)

export default component.exports